
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import { EstimationClient } from '@/services/Services';
import utils from '@/utils';
import * as OM from '@/Model';

@Options({})
export default class addLayerProductionProcessModal extends Vue {

    @Prop() estimationIdentifier: string;
    @Prop() layer: OM.LayerComposition;
    @Prop() allProductionProcesses: OM.ProductionProcessListVM[];
    @Prop() currentProductionProcesses: OM.FabricProductionProcess[];
    @Prop() countries: OM.TextIdentifier[];
    @Prop() productionPhase: string;
    @Prop() saveCallback: (layer: OM.AddEstimationLayerProductionProcessVM) => void;
    @Prop() liquidPolymerAndTechniqueSavedCallback: () => void;
    @Prop() productionProcessName: string;

    model = new OM.AddEstimationLayerProductionProcessVM();
    originCountryReadonly: boolean = false;
    hideMaterialsSelection: boolean = false;

    processSelectedHasCustomField: boolean = false;

    liquidPolymerAndTechniqueSelected: OM.ProductionProcessListVM = null;
    selectedLiquidPolymerKey: string = "";
    selectedTechniqueKey: string = "";
    liquidPolymerAndTechniqueVM: OM.EditEstimationLayerLiquidPolymerAndTechniqueProductionProcessVM = new OM.EditEstimationLayerLiquidPolymerAndTechniqueProductionProcessVM();

    created() {
        this.model.productionProcessIdentifier = this.allProductionProcesses.find(x => x.name == this.productionProcessName)?.identifier;
        // this.countries.unshift({
        //     text: this.$localizationService.getLocalizedValue("Generic", "Generic"),
        //     identifier: ""
        // });
        
        this.model.identifier = this.estimationIdentifier;
        this.model.layerName = this.layer.layerName;

        this.hideMaterialsSelection = utils.checkIfProductionPhaseIsNextFabric(this.productionPhase);
        (<any>window).sam = this.currentProductionProcesses;
    }

    get isStitchingTimeSelected(): boolean {
        const process = this.allProductionProcesses.find(x => x.identifier == this.model.productionProcessIdentifier);
        return process?.name?.trim().toLowerCase() === 'stitching time';
    }

    get disabled(){
        var baseCheck = !this.model.productionProcessIdentifier;

        if(this.liquidPolymerAndTechniqueSelected != null)
            baseCheck = baseCheck || !this.selectedLiquidPolymerKey || !this.selectedTechniqueKey;

        return baseCheck;
    }

    get filteredEmissionCalculationProcesses() {
        let usati = this.currentProductionProcesses
            .reduce((final, x) => {
                if(!final[x.name]) //inizializza
                    final[x.name] = 0;

                final[x.name]++;
                return final;
            }, {})

        return this.allProductionProcesses
            .filter(x => !x.isMandatory && !usati[x.name] && x.isLiquidPolymerAndTechniqueProcess)
    }

    get filteredAllProductionProcesses(){
        let usati = this.currentProductionProcesses
            .reduce((final, x) => {
                if(!final[x.name]) //inizializza
                    final[x.name] = 0;

                final[x.name]++;
                return final;
            }, {})
        let uniques = this.currentProductionProcesses
            .filter(x => x.isUnique);

        return this.allProductionProcesses
            .filter(x => !x.rawMaterialIndipendent && !x.isUnitCalculated && (!usati[x.name] || usati[x.name] < this.layer.fabricCompositions.length)) // && !uniques.some(c => c.name == x.name))
            .filter(x => !uniques.some(c => c.uniqueKey == x.uniqueKey))
            .reduce((final, x) => {
                if(!final[x.uniqueKey])
                    final[x.uniqueKey] = [];

                final[x.uniqueKey].push({
                    identifier: x.identifier,
                    text: x.name,
                });
                return final;
            }, {})
    }

    get filteredRawMaterials(){
        var process = this.allProductionProcesses.find( x => x.identifier == this.model.productionProcessIdentifier)
        let uniques = this.currentProductionProcesses
            .filter(x => x.isUnique)
            .reduce((final, x) => {
                if(!final[x.uniqueKey])
                    final[x.uniqueKey] = [];
                
                final[x.uniqueKey].push(x.rawMaterial.identifier)

                return final;
            }, {});

        return this.layer.fabricCompositions
            .filter( x => !process.isUnique || 
                (
                    Object.keys(uniques).indexOf(process.uniqueKey) == -1 || 
                    uniques[process.uniqueKey].indexOf(x.rawMaterial.identifier) == -1
                ))
            .map( x => x.rawMaterial);
    }

    get isUnitCalculated(){
        if(!this.model.productionProcessIdentifier)
            return false;

        return this.allProductionProcesses.find( x => x.identifier == this.model.productionProcessIdentifier).isUnitCalculated;
    }

    addOrRemoveRawMaterial(identifier: string){
        var add = Object.keys(this.model.rawMaterialCountryAndUnits).indexOf(identifier) == -1;

        if(!add){
            delete this.model.rawMaterialCountryAndUnits[identifier];
            return;
        }

        EstimationClient.getCountryOfDestinationFromPreviousStep(this.estimationIdentifier, identifier, this.productionPhase, this.layer.layerName)
        .then( x => {
            var country = this.countries.find(y => y.text == x).identifier;
            this.model.rawMaterialCountryAndUnits[identifier] = {
                key: country,
                value: 0
            }
        })
    }

    async addEveryMaterial() {
        var promises = this.filteredRawMaterials.map(async (element) => {
            var materialRis = await EstimationClient.getCountryOfDestinationFromPreviousStep(this.estimationIdentifier, element.identifier, this.productionPhase, this.layer.layerName);
            var getCountryRis = {
                materialId: element.identifier,
                countryId: materialRis
            }
            return getCountryRis;
        });

        var ris = await Promise.all(promises);
        ris.forEach(element => {
            var country = this.countries.find(y => y.text == element.countryId).identifier;
            if(this.liquidPolymerAndTechniqueSelected == null) {
                this.model.rawMaterialCountryAndUnits[element.materialId] = {
                    key: country,
                    value: 0
                }
            }
            else {
                this.liquidPolymerAndTechniqueVM.rawMaterialCountryAndUnits[element.materialId] = {
                    key: country,
                    value: 0
                }
            }
        });
    }

    checkTypeOfProcess() {
        this.processSelectedHasCustomField = this.allProductionProcesses.filter(x => x.identifier == this.model.productionProcessIdentifier)[0].hasCustomAmount;
        this.liquidPolymerAndTechniqueSelected = this.filteredEmissionCalculationProcesses.filter(x => x.identifier == this.model.productionProcessIdentifier)[0];
    }

    async save() {
        if(this.liquidPolymerAndTechniqueSelected != null) {
            var ris = await this.addEveryMaterial();
            this.liquidPolymerAndTechniqueVM.liquidPolymer = this.liquidPolymerAndTechniqueSelected.emissionCalculation.liquidPolymer.filter(x => x.key == this.selectedLiquidPolymerKey)[0];
            this.liquidPolymerAndTechniqueVM.technique = this.liquidPolymerAndTechniqueSelected.emissionCalculation.technique.filter(x => x.key == this.selectedTechniqueKey)[0];
            this.liquidPolymerAndTechniqueVM.identifier = this.estimationIdentifier;
            this.liquidPolymerAndTechniqueVM.layerName = this.layer.layerName;
            this.liquidPolymerAndTechniqueVM.productionProcessIdentifier = this.liquidPolymerAndTechniqueSelected.identifier;

            EstimationClient.editLiquidPolymerAndTechniqueProductionProcess(this.liquidPolymerAndTechniqueVM)
            .then(x => {
                this.liquidPolymerAndTechniqueSavedCallback();
            })
        }
        else {
            if(this.hideMaterialsSelection) {
                var ris = await this.addEveryMaterial();
                this.saveCallback(this.model);
            }
            else
                this.saveCallback(this.model);
        }

    }
}
